export default {
  logs: 'Логи сервера',
  configuration: 'Настройки сервера',
  settings: {
    title: 'Общие настройки'
  },
  input_config: {
    title: 'Входная конфигурация'
  },
  output_config: {
    title: 'Исходящая конфигурация'
  },
  preprocessor: {
    title: 'Препроцессор'
  },
  postprocessor: {
    title: 'Постпроцессор'
  },
  local_db: {
    title: 'Локальная БД'
  },
  visual_sample: {
    title: 'Визуальный пример'
  },
  stream: {
    title: 'Стрим'
  },
  model: {
    title: 'Модель',
    upload_image_sample: 'загрузить изображение',
    remove: 'Удалить модель',
    reset: 'Сбросить параметры',
    add_model: 'Добавить модель',
    library: 'Библиотека моделей'
  },
  models: {
    title: 'Модели'
  },
  sources: {
    title: 'Источники'
  },
  source: {
    title: 'Источник'
  },
  pipelines: {
    title: 'Пайплайны',
    add_new: 'Создать новый пайплайн'
  },
  outputs: {
    title: 'Выходы'
  },
  table: {
    created: 'Был создан',
    name: ' Название',
    status: 'Статус',
    inputs: 'Ресурсы',
    host: 'Локальный IP / Соединение',
    server_id: 'ID сервера',
    server_type: 'Тип',
    model: 'Модель',
    start: 'Запустить/Остановить',
    remove: 'Удалить',
    piplinesOf: 'пайплайнов из',
    commonModel: 'общей модели'
  },
  input: {
    name: 'Имя',
    model: 'Выберите модель',
    notes: 'Заметки'
  },
  actions: {
    run: 'Запустить',
    stop: 'Остановить',
    delete: 'Удалить'
  }
}
